import {
  authReq
} from '@/utils/http'

const getAgents = (page = 1, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/agent', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const addAgent = (data) => {
  const formData = new FormData()
  formData.append('agentname', data.agentname)
  formData.append('nickname', data.nickname)
  formData.append('phone', data.phone)
  formData.append('business', data.business)
  formData.append('app_id', data.app_id)
  formData.append('app_secret', data.app_secret)
  formData.append('password', data.password)
  formData.append('is_oper_pwd', data.is_oper_pwd)
  formData.append('oper_pwd', data.oper_pwd)
  formData.append('fee_value', data.fee_value)
  formData.append('pay_channel', data.pay_channel)
  formData.append('pay_title', data.pay_title)
  formData.append('pay_domain', data.pay_domain)
  formData.append('wechat_admin_domain', data.wechat_admin_domain)
  formData.append('wechat_auth_domain', data.wechat_auth_domain)
  formData.append('logo_icon', data.logo_icon)
  formData.append('logo_color_full', data.logo_color_full)
  formData.append('logo_white_full', data.logo_white_full)
  formData.append('cn_copy_right', data.cn_copy_right)
  formData.append('en_copy_right', data.en_copy_right)
  formData.append('sub_user_suffix', data.sub_user_suffix)
  formData.append('remarks', data.remarks)
  return authReq.post('/api/v1/agent', formData)
}

const editAgent = (data) => {
  console.log('data', data)
  const formData = new FormData()
  formData.append('agentid', data.agentid)
  formData.append('agentname', data.agentname)
  formData.append('nickname', data.nickname)
  formData.append('phone', data.phone)
  formData.append('business', data.business)
  formData.append('app_id', data.app_id)
  formData.append('app_secret', data.app_secret)
  formData.append('password', data.password)
  formData.append('is_oper_pwd', data.is_oper_pwd)
  formData.append('oper_pwd', data.oper_pwd)
  formData.append('fee_value', data.fee_value)
  formData.append('pay_channel', data.pay_channel)
  formData.append('pay_title', data.pay_title)
  formData.append('pay_domain', data.pay_domain)
  formData.append('wechat_admin_domain', data.wechat_admin_domain)
  formData.append('wechat_auth_domain', data.wechat_auth_domain)
  if (data.logo_icon !== '') {
    formData.append('logo_icon', data.logo_icon)
  }
  if (data.logo_color_full !== '') {
    formData.append('logo_color_full', data.logo_color_full)
  }
  if (data.logo_white_full !== '') {
    formData.append('logo_white_full', data.logo_white_full)
  }
  formData.append('cn_copy_right', data.cn_copy_right)
  formData.append('en_copy_right', data.en_copy_right)
  formData.append('sub_user_suffix', data.sub_user_suffix)
  formData.append('remarks', data.remarks)
  return authReq.put('/api/v1/agent', formData)
}

export default {
  getAgents,
  addAgent,
  editAgent
}



// WEBPACK FOOTER //
// ./src/api/agentApi.js